// extracted by mini-css-extract-plugin
module.exports = {"list-item":"NavigationLink_list-item__sVvrp","link":"NavigationLink_link__3jQz1"};